import React from 'react'

import { Form, Col } from '_zari/core'

import { MesContabilidadSelect } from 'sharedComponents/select'

const MesContabilidadFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='MES' htmlFor='select-mes' md={4} alignRightAt='md' />
      <Col md={8}>
        <MesContabilidadSelect name='select-mes' id='select-mes' value={value} onChange={onChange} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MesContabilidadFormGroup)
